import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */

const apiCaller = getApiInstance('gitlab');

function getAllIssues(page) {
    return (dispatch, getState) => {
        const assigneeIds = getState().environments.myfhe.gitlabApi.get('assigneeIds');
        const groupId = getState().environments.myfhe.gitlabApi.get('groupId');
        return apiCaller
            .call(api.getAllIssues(page, assigneeIds, groupId))
            .then(({ data, response }) => {
                if (response.status === 200) {
                    const pages = {
                        current: parseInt(response.headers.get('x-page')),
                        total: parseInt(response.headers.get('x-total-pages')),
                        next: parseInt(response.headers.get('x-next-page'))
                    };

                    let issues = {};
                    data.forEach(({ id, iid, title, project_id, created_at, state }) => {
                        issues[id] = { iid, title, project_id, created_at, state };
                    });
                    dispatch({
                        type: 'MYFHE_GIT__SET_ISSUES',
                        issues,
                        currentPage: pages.current,
                        nextPage: pages.next,
                        totalPages: pages.total
                    });
                    return pages;
                } else throw new Error('issues_have_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: getAllIssues - ', error);
                throw error;
            });
    };
}
function getIssue(projectID, issueId) {
    return dispatch => {
        return apiCaller
            .call(api.getIssue(projectID, issueId))
            .then(({ data }) => {
                if (data) {
                    const { id, iid, title, description, project_id, created_at, state, web_url } = data;
                    const author = data.author.name;
                    const issue = { [id]: { iid, title, description, project_id, created_at, state, web_url, author } };
                    dispatch({
                        type: 'MYFHE_GIT__SET_ISSUE',
                        issue
                    });
                    return data;
                } else throw new Error('issue_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: getIssue - ', error);
                throw error;
            });
    };
}
function updateIssue(projectID, issueId, formIssue) {
    return dispatch => {
        return apiCaller
            .call(api.updateIssue(projectID, issueId, formIssue))
            .then(({ data }) => {
                if (data) {
                    const { id, iid, title, description, project_id, created_at, state, web_url } = data;
                    const author = data.author.name;
                    const issue = { [id]: { iid, title, description, project_id, created_at, state, web_url, author } };

                    dispatch({
                        type: 'MYFHE_GIT__SET_ISSUE',
                        issue
                    });
                    return data;
                } else throw new Error('issue_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: updateIssue - ', error);
                throw error;
            });
    };
}
function createIssue(formIssue) {
    return (dispatch, getState) => {
        const assigneeIds = getState().environments.myfhe.gitlabApi.get('assigneeIds');
        return apiCaller
            .call(api.createIssue(formIssue, assigneeIds))
            .then(({ data }) => {
                if (data) {
                    const { id, iid, title, description, project_id, created_at, state, web_url } = data;
                    const author = data.author.name;
                    const issue = { [id]: { iid, title, description, project_id, created_at, state, web_url, author } };

                    dispatch({
                        type: 'MYFHE_GIT__SET_ISSUE',
                        issue
                    });
                    return data;
                } else throw new Error('issue_has_not_been_correctly_returned_by_server');
            })
            .catch(error => {
                Logger.error('dataActions: createIssue - ', error);
                throw error;
            });
    };
}

export { getAllIssues, getIssue, updateIssue, createIssue };



// WEBPACK FOOTER //
// ./environments/myfhe/data/Issues/actions.js